import React, { useState } from "react";
import ChatBot from "../VapiAssistant/ChatBot";

// The FAQ uses exactly the same public-key widget and account variables as Home.
// Private Vapi credentials must never be included in the customer app.
const FAQAI = () => {
  const [language, setLanguage] = useState("");
  return <div className="main-wrapper">
    <div className="chat-container">
      <div className="chat-container-header">
        <h1>{language === "en" ? "Ask our Salsa People AI Friday" : "Frage unseren Salsa People KI Friday"}</h1>
        <label htmlFor="faq-chat-language">{language === "en" ? "Choose your language:" : "Wähle deine Sprache:"}</label>
        <select id="faq-chat-language" value={language} onChange={e => setLanguage(e.target.value)} className="dropdown">
          <option value="">Bitte wählen / Please select</option>
          <option value="de">Deutsch</option>
          <option value="en">English</option>
        </select>
        <p>{language === "en" ? "Open the chat at the bottom right to ask your question." : "Öffne den Chat unten rechts, um deine Frage zu stellen."}</p>
      </div>
    </div>
    {language && <ChatBot language={language} />}
  </div>;
};
export default FAQAI;
